var exports = {
  "p": "xdde3148b--67caba--list",
  "A": "xdde3148b--67caba--item",
};

module.exports = exports;
